import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { NgForm } from '@angular/forms';
import { LoginData, QuproServiceError } from '@arpada/arp-lib-common-qupro';
import { PortalProveedorService, MessagesService, UiService } from '../../services/api.services';

@Component({
  selector: 'app-cambio-password',
  templateUrl: './cambio-password.component.html',
  styleUrls: ['./cambio-password.component.scss'],
})
export class CambioPasswordComponent implements OnInit {
  @Input() canCancel: boolean;
  @ViewChild('formulario', { static: true }) formulario: NgForm;

  cambioPassword = {
    newPassword: '',
    confirmNewPassword: ''
  };
  loadingChangePassword = false;

  constructor(private modalCtrl: ModalController,
              private portalProveedorService: PortalProveedorService,
              private uiService: UiService,
              private messagesService: MessagesService) { }

  ngOnInit() {}

  onSubmitform() {
    if (this.formulario.invalid) { return; }
    if (this.loadingChangePassword) { return; } // Not multiple submit
    this.loadingChangePassword = true;
    this.portalProveedorService.changePassword(this.cambioPassword.newPassword).subscribe( resp => {
      try {
        this.portalProveedorService.loginAfterChangePassword(this.cambioPassword.newPassword)
          .subscribe( (loginData: LoginData) => {
            this.loadingChangePassword = false;
            this.uiService.showSimpleMiddleToast(this.messagesService.getSuccessChangePassword(), 2000);
            this.modalCtrl.dismiss();
          }, (error: QuproServiceError) => {
            this.loadingChangePassword = false;
            this.portalProveedorService.logger.error(
              '[CambioPasswordComponent] Error (qupro) al intentar hacer login despues del cambio de contraseña.', error);
            const message: string = this.messagesService.canNotLoginAfterChangePasswordMessage();
            this.uiService.presentAlert(this.messagesService.getErrorHeaderLabel(),
                                        this.messagesService.getErrorChangePasswordHeader(), message);
            this.modalCtrl.dismiss();
          });
      } catch (error) {
        this.loadingChangePassword = false;
        this.uiService.presentAlert(this.messagesService.getErrorHeaderLabel(),
                                    this.messagesService.getErrorChangePasswordHeader(), error.message);
        this.portalProveedorService.logger.error(
          '[CambioPasswordComponent] Error (exception) al intentar hacer login despues del cambio de contraseña.', error);
      }
    }, (error: QuproServiceError) => {
      this.loadingChangePassword = false;
      this.portalProveedorService.logger.error('[CambioPasswordComponent] Error (qupro) al intentar cambiar de contraseña.', error);
      const message: string = this.messagesService.canNotChangePasswordMessage();
      this.uiService.presentAlert(this.messagesService.getErrorHeaderLabel(),
                                  this.messagesService.getErrorChangePasswordHeader(), message);
      this.modalCtrl.dismiss();
    });
  }

  salir() {
    this.modalCtrl.dismiss();
  }

}
